// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionStyle: 'style2',
    //enableDefaultResult: true
    suggestionMobileStyle: 'style2',
    highlightSuggestionResult: false,
    suggestionStyle2MainContainerSelector: '.header-search',
    isLoggedIn: document.body.dataset.isLoggedIn === 'CustomerDrop' ? true : false,
  }
};

(function() {
  var firstVariant = {};
  var metafields = {
    'product_short_name': '',
    'product_subtitle': '',
    'background_image': '',
  };

  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
    if (!suggestionElement) suggestionElement = this.$uiMenuElement;
    if (!searchElement) searchElement = this.$element;
    if (!searchBoxId) searchBoxId = this.id;
  };

  InstantSearchResult.prototype._applyFilterAutocompleteAppendElement = function() {
    this.appendToSelector = '.header-search';
  };

  InstantSearchApi.afterCall = function(result) {
    if( result.all_empty ) {
      jQuery('.header-search').addClass('no-results');
    }
    else {
      jQuery('.header-search').removeClass('no-results');
    }
  };

  InstantSearchResult.prototype.afterInit = function() {
    InstantSearchResult.prototype.afterRender()
  }

  InstantSearchResult.prototype.afterRender = function () {

    const variants = document.querySelectorAll('.boost-pfs-search-suggestion-wrapper [data-product-item-variant]')

    variants.forEach((variant) => {
      const variantId = variant.getAttribute('data-product-item-variant')

      variant.addEventListener('click', (e) => {
        e.preventDefault()

        const item = {
          id: parseFloat(variantId),
          quantity: 1
        }

        VueMinicart.$store.dispatch('addItem', item)
      })
    })
  }

  function prepareShopifyData(data) {
    // Get First Variant (selected_or_first_available_variant)
    firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function(e) {
        return e.id == Utils.getParam('variant');
      });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          firstVariant = data['variants'][i];
          break;
        }
      }
    }

    if (data.hasOwnProperty('metafields')) {
      var namespace = 'accentuate';
      metafields.packaging_type = Utils.getProductMetafield(data, namespace, 'packaging_type');
      metafields.product_short_name = Utils.getProductMetafield(data, namespace, 'product_short_name') || data.title;
      metafields.product_subtitle = Utils.getProductMetafield(data, namespace, 'product_subtitle');
      metafields.ProductListingSnippet = Utils.getProductMetafield(data, 'okendo', 'ProductListingSnippet');
      metafields.background_image = JSON.parse(Utils.getProductMetafield(data, namespace, 'background_image'));
    } else {
      var no_result_metafields = JSON.parse(document.getElementById('boost-pfs-instant-search-metafields-not-found-json').textContent);

      metafields = {
        'product_short_name': no_result_metafields[data.id].product_short_name,
        'product_subtitle': no_result_metafields[data.id].product_subtitle,
        'background_image': no_result_metafields[data.id].background_image,
      };
    }

    return data
  }

  InstantSearchResultItemProduct.prototype.compileTemplate = function(data){
    if (!data) data = this.data
    data = prepareShopifyData(data)
    firstVariant = data['variants'][0]

    var itemHtml = '<li class="boost-pfs-search-product-tile"><figure class="product-tile product-tile--standard" data-product-item>' +
      '{{itemBadge}}' +
      '<div class="product-tile__media packaging_type__{{packagingType}}">' +
        '<a href="{{itemUrl}}" class="product-tile__link product-tile__link--media">' +
          '{{itemImages}}' +
        '</a>' +
      '</div>' +
      '<div class="product-tile__info">' +
        '<figcaption class="product-tile__info-header">' +
          '<a href="{{itemUrl}}" class="product-tile__link"><h3 class="product-tile__title">{{itemTitle}}</h3></a>' +
          '<p class="product-tile__subtitle">{{itemSubtitle}}</p>' +
          '<p class="product-tile__price">' + (boostPFSInstantSearchConfig.search?.isLoggedIn ? '{{itemPrice}}' : 'Login to see price') + '</p>' +
        '</figcaption>' +
        '<div class="product-tile__info-buttons">' +
          '{{itemButtons}}' +
          '{{ProductListingSnippet}}' +
        '</div>' +
      '</div>' +
    '</figure></li>';

    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
    // Add Badge
    itemHtml = itemHtml.replace(/{{itemBadge}}/g, buildBadge(data));
    // Add buttons
    itemHtml = itemHtml.replace(/{{itemButtons}}/g, buildButtons(data));
    // Add reviews
    itemHtml = itemHtml.replace(/{{ProductListingSnippet}}/g, metafields.hasOwnProperty('ProductListingSnippet') && metafields.ProductListingSnippet ? '<div data-oke-reviews-product-listing-rating>'+ metafields.ProductListingSnippet.replace(/span/g, 'div') +'</div>' : '');
    // Add price
    let productPrice = parseFloat(firstVariant.price)
    if (data.tags.indexOf(window.productDiscountException) < 0) {
      productPrice = productPrice * window.customerDiscount;
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, Utils.formatMoney(productPrice));
    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, firstVariant.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, metafields.product_short_name );
    itemHtml = itemHtml.replace(/{{itemSubtitle}}/g, jQuery('<div/>').html(metafields.product_subtitle).text());
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, '/products/' + data.handle);
    // Add Package Type Class
    itemHtml = itemHtml.replace(/{{packagingType}}/g, (metafields.packaging_type || 'standard').replace(/\W+/g, '-').toLowerCase());
    return itemHtml;
  }

  function buildImages(data) {
    var html = '';
    var bg_image = metafields.hasOwnProperty('background_image') ? metafields.background_image : false;
    var images = data.images_info;
    if (!images || images.length == 0){
      images.push({
          src: boostPFSAppConfig.general.no_image_url,
          width: 340,
          height: 340
      });
    }

    var featured_image_src = Utils.optimizeImage(data.images_info[0].src, '340x340');

    if (bg_image) {
      if (bg_image[0].mime_type.includes('gif')) {
        html += '<img src="'+ bg_image[0].original_src +'" class="product-tile__bg" />';
      }
      else if (bg_image[0].media_type == 'video') {
        html += `
          <video class="product-tile__bg" width="${bg_image[0].width}" height="${bg_image[0].height}" autoplay muted loop>
            <source src="${bg_image[0].src}" type="video/mp4">
          </video>
        `;
      }
      else {
        html += '<img src="'+ bg_image[0].cloudinary_src + 'w_680' +'" class="product-tile__bg" />';
      }
    }

    html += '<img src="'+ featured_image_src +'" class="product-tile__image" />';
    return html;
  }

  function buildButtons(data) {
    var html = '';

    if (data.variants.length == 1) {
      html += '<button type="button" class="product-tile__button" data-product-item-variant="{{itemId}}"';

      if( !data.available ){
        html += ' disabled>' + 'Sold Out';
      }
      else {
        html += '>' + 'Add to Bag' + '<span class="product-tile__button-extra">&nbsp;&dash;&nbsp;{{itemPrice}}</span>';
      }

      html += '</button>';
    }
    else {
      html += '<a href="{{itemUrl}}" class="product-tile__button">Shop Now</a>';
    }

    return html;
  }

  function buildBadge(data) {
    var badgeLabel = '';
    if (data.tags) {
      for (var i = data.tags.length - 1; i >= 0; i--) {
        tag = data.tags[i];
        if (tag.indexOf("Badge:") !== -1) {
          badgeLabel += tag.split('Badge:')[1];
          break;
        }
      }
    }

    if (badgeLabel != '') {
      return '<div class="product-badge">' +
        '<span class="product-badge__text">'+ badgeLabel +'</span>' +
      '</div>';
    }
    else {
      return '';
    }
  }

  InstantSearchResultItemProduct.prototype.afterRender = function(){
    new ProductTile();
  }

  function buildLanding( search_value = '' ) {
    var $suggestion_wrapper = jQuery('.boost-pfs-search-suggestion-wrapper > ul.boost-pfs-search-suggestion');
    if( search_value === "" ) {
      var landing_html = jQuery('.header-search__landing').html();
      $suggestion_wrapper.html( landing_html );
      $suggestion_wrapper.parent().addClass('landing');
      $suggestion_wrapper.show();
      InstantSearchResult.prototype.afterRender()
    }
    else {
      $suggestion_wrapper.parent().removeClass('landing');
    }
  }

  SearchInput.prototype._onFocusSearchBox = function(event) {
    buildLanding( event.target.value );
  }

  SearchInput.prototype._onTypeSearchBoxEvent = function(event) {
    buildLanding( event.target.value );
  }

  jQuery('[data-search-button-open]').on('click', function(){
    document.querySelector('#boost-pfs-search-box-0').focus();
  });

})();
